import filter from "./filter.js";
import matcher from "./matcher.js";
export default function where(obj, attrs) {
  return filter(obj, matcher(attrs));
}
